import { createFeatureSelector, createSelector, select } from '@ngrx/store';
import { pipe } from 'rxjs';
import { distinctUntilChanged, filter } from 'rxjs/operators';
import { selectEquipment } from '../equipment/equipment.selectors';
import { EffectLoadingState } from '../shared/models/effect-state';
import { selectVehiclesForUser } from '../vehicle';
import { garageFeatureKey, GarageState } from './garage.reducer';

export const equipmentState =
    createFeatureSelector<GarageState>(garageFeatureKey);

export const selectGarageItemId = createSelector(
    equipmentState,
    (state) => state.activeGarageItemId
);

export const selectGarageItemsLoaded = createSelector(
    equipmentState,
    (state) => state.effectState === EffectLoadingState.Loaded
);

export const selectGarageItemsLoading = createSelector(
    equipmentState,
    (state) => state.effectState === EffectLoadingState.Loading
);

export const selectActiveGarageItem = createSelector(
    selectEquipment,
    selectVehiclesForUser,
    selectGarageItemId,
    (equipment, vehicles, selectedId) => {
        const foundEquipment = equipment.find(
            (equip) => equip.id === selectedId
        );
        const foundVehicle = vehicles.find(
            (vehicle) => vehicle.id === selectedId
        );
        if (foundVehicle) {
            return foundVehicle;
        } else if (foundEquipment) {
            return foundEquipment;
        } else {
            return null;
        }
    }
);

export const selectActiveGarageItemVehicleId = createSelector(
    selectVehiclesForUser,
    selectGarageItemId,
    (vehicles, selectedId) => {
        const foundVehicle = vehicles.find(
            (vehicle) => vehicle.id === selectedId
        );

        if (foundVehicle) {
            return foundVehicle.id;
        }
        return null;
    }
);

export const selectGarageItems = createSelector(
    selectEquipment,
    selectVehiclesForUser,
    (equipment, vehicles) => {
        return [...vehicles, ...equipment];
    }
);

export const pipeActiveGarageItem = pipe(
    select(selectActiveGarageItem),
    filter((garageItem) => Boolean(garageItem)),
    distinctUntilChanged((a, b) => a?.id !== b?.id)
);
